import React, { useState } from "react";
import { format } from "date-fns";
import { FaHistory, FaLaptop, FaCommentAlt } from 'react-icons/fa';
import styles from "./Card.module.css";
import TicketModal from "../../view/TicketDetailModal/TicketDetailModal";

function Card({ ticketData, equipoCod, area, isMto }) {
    const { registros } = ticketData;
    const [showModal, setShowModal] = useState(false);
    const [selectedTicketId, setSelectedTicketId] = useState(null);
    // console.log("TRAE::",registros)
    const formatFecha = (fecha) => {
        return format(new Date(fecha), "yyyy-MM-dd HH:mm:ss");
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTicketId(null);
    };

    const handleShowModal = (ticketId) => {
        setSelectedTicketId(ticketId);
        setShowModal(true);
    };

    const shouldRender =
        registros &&
        registros.length > 0 &&
        registros[0].estadoDescripcion !== "Cerrado" &&
        registros[0].estadoDescripcion !== "Cancelado";

    if (!shouldRender) {
        return null;
    }

    let cardClassName = styles.card;

    switch (registros[0].estadoDescripcion) {
        case "Creado":
            cardClassName += ` ${styles.open}`;
            break;
        case "En Proceso":
            cardClassName += ` ${styles.inProgress}`;
            break;
        case "Pendiente":
            cardClassName += ` ${styles.pending}`;
            break;
        case "Resuelto":
            cardClassName += ` ${styles.resuelto}`;
            break;
        default:
            break;
    }

    return (
        <div className={cardClassName}>
            <div className={styles.cardHeader}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <div className={styles.ticketBadge}>
                        <span className={styles.ticketId}>#{registros[0].TicketId}</span>
                    </div>
                    {area && (
                        <span className={`${styles.areaBadge} ${isMto ? styles.mtoBadge : styles.tiBadge}`}>
                            {area}
                        </span>
                    )}
                </div>
                <div className={`${styles.statusBadge} ${styles[registros[0].estadoDescripcion.replace(/\s+/g, '').toLowerCase()]}`}>
                    {registros[0].estadoDescripcion}
                </div>
            </div>

            <div className={styles.cardBody}>
                <div className={styles.infoRow}>
                    <div className={styles.iconLabel}>
                        <FaHistory className={styles.icon} />
                        <span className={styles.label}>Actualizado:</span>
                    </div>
                    <span className={styles.value}>{formatFecha(registros[0].fecha)}</span>
                </div>

                <div className={styles.infoRow}>
                    <div className={styles.iconLabel}>
                        <FaLaptop className={styles.icon} />
                        <span className={styles.label}>Equipo:</span>
                    </div>
                    <span className={styles.value}>{equipoCod}</span>
                </div>

                <div className={styles.observacionSection}>
                    <div className={styles.iconLabel}>
                        <FaCommentAlt className={styles.icon} />
                        <span className={styles.label}>Observación:</span>
                    </div>
                    <p className={styles.observacionText}>{registros[0].observacion}</p>
                </div>
            </div>

            <div className={styles.cardFooter}>
                <button className={styles.detailButton} onClick={() => handleShowModal(registros[0].TicketId)}>
                    Ver Detalle
                </button>
            </div>

            <TicketModal
                show={showModal}
                onHide={handleCloseModal}
                ticketId={selectedTicketId}
                equipoCod={equipoCod}
                flag={registros[0].flag}
                registros={registros}
            />
        </div>
    );
}

export default Card;
